module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect h-100",
    attrs: {
      "id": "modalSaisieOeth"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content h-100"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body mr-3 mt-3 pt-0"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-2 mr-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.Annee),
      expression: "declarationOETH.Annee"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": " "
    },
    domProps: {
      "value": (_vm.declarationOETH.Annee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.declarationOETH, "Annee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Année d'exercice")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input-number', {
    attrs: {
      "label": "Effectif moyen annuel de l'entreprise",
      "disabled": _vm.readOnly,
      "error": _vm.errorInputEffectifTotal,
      "vmodel": _vm.declarationOETH.EffectifTotal
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "EffectifTotal", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3 no-gutters"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-2 mr-3"
  }, [_c('input-number', {
    attrs: {
      "label": "Agés de -50 ans",
      "maxlength": "4",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.BoethInterneMoinsDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "BoethInterneMoinsDeCinquanteAns", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Agés de +50 ans",
      "maxlength": "4",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.BoethInternePlusDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "BoethInternePlusDeCinquanteAns", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center no-gutters"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-2 mr-3"
  }, [_c('input-number', {
    attrs: {
      "label": "Agés de -50 ans",
      "maxlength": "4",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.BoethExterneMoinsDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "BoethExterneMoinsDeCinquanteAns", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Agés de +50 ans",
      "maxlength": "4",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.BoethExternePlusDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "BoethExternePlusDeCinquanteAns", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-radio",
    class: (_vm.errorRadioAccordAgree) ? 'error' : ''
  }, [_c('span', {
    staticClass: "text flex-grow-1 ml-3"
  }, [_vm._v("Votre entreprise est-elle concernée par un accord agréé ?")]), _vm._v(" "), _c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.AccordAgree),
      expression: "declarationOETH.AccordAgree"
    }],
    attrs: {
      "type": "radio",
      "name": "radioAccordAgree",
      "disabled": _vm.readOnly,
      "id": "radioAccordAgreeOui",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.AccordAgree, "true")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "AccordAgree", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAccordAgreeOui"
    }
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.AccordAgree),
      expression: "declarationOETH.AccordAgree"
    }],
    attrs: {
      "type": "radio",
      "name": "radioAccordAgree",
      "disabled": _vm.readOnly,
      "id": "radioAccordAgreeNon",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.AccordAgree, "false")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "AccordAgree", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAccordAgreeNon"
    }
  }, [_vm._v("Non")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-radio",
    class: (_vm.errorRadioAccueilBoeth) ? 'error' : ''
  }, [(_vm.declarationOETH.Annee != null) ? _c('span', {
    staticClass: "text flex-grow-1 ml-3"
  }, [_vm._v("\n                                 Avez-vous accueilli des BOETH au cours des 4 dernières années (depuis " + _vm._s(_vm.declarationOETH.Annee - 3) + ") ?\n                               ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.AccueilBoethSurQuatreAns),
      expression: "declarationOETH.AccueilBoethSurQuatreAns"
    }],
    attrs: {
      "type": "radio",
      "name": "radioBoeth",
      "disabled": _vm.readOnly,
      "id": "radioBoethOui",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.AccueilBoethSurQuatreAns, "true")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "AccueilBoethSurQuatreAns", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioBoethOui"
    }
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.AccueilBoethSurQuatreAns),
      expression: "declarationOETH.AccueilBoethSurQuatreAns"
    }],
    attrs: {
      "type": "radio",
      "name": "radioBoeth",
      "disabled": _vm.readOnly,
      "id": "radioBoethNon",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.AccueilBoethSurQuatreAns, "false")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "AccueilBoethSurQuatreAns", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioBoethNon"
    }
  }, [_vm._v("Non")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-radio",
    class: (_vm.errorRadioRecoursSousTraitance) ? 'error' : ''
  }, [(_vm.declarationOETH.Annee != null) ? _c('span', {
    staticClass: "text flex-grow-1 ml-3"
  }, [_vm._v("\n                                 Votre entreprise a-t-elle eu recours à des montants de sous-traitance avec le STPA au cours des 4 dernières années (depuis " + _vm._s(_vm.declarationOETH.Annee - 3) + ") pour un montant minimum de 7128€ ?\n                               ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.RecoursSousTraitanceSurQuatreAns),
      expression: "declarationOETH.RecoursSousTraitanceSurQuatreAns"
    }],
    attrs: {
      "type": "radio",
      "name": "radioStpa",
      "disabled": _vm.readOnly,
      "id": "radioStpaOui",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.RecoursSousTraitanceSurQuatreAns, "true")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "RecoursSousTraitanceSurQuatreAns", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioStpaOui"
    }
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declarationOETH.RecoursSousTraitanceSurQuatreAns),
      expression: "declarationOETH.RecoursSousTraitanceSurQuatreAns"
    }],
    attrs: {
      "type": "radio",
      "name": "radioStpa",
      "disabled": _vm.readOnly,
      "id": "radioStpaNon",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.declarationOETH.RecoursSousTraitanceSurQuatreAns, "false")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.declarationOETH, "RecoursSousTraitanceSurQuatreAns", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioStpaNon"
    }
  }, [_vm._v("Non")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Valeur",
      "disabled": _vm.readOnly,
      "decimal": false,
      "vmodel": _vm.declarationOETH.EffectifEcap
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "EffectifEcap", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseSousTraitance
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseSousTraitance", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseDiagnosticEtTravauxBoeth
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseDiagnosticEtTravauxBoeth", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseCompensationHandicap
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseCompensationHandicap", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseAccompagnementBoeth
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseAccompagnementBoeth", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseParticipationEvenement
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseParticipationEvenement", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepensePartenariatAssociation
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepensePartenariatAssociation", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.DepenseProfessionnalisation
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "DepenseProfessionnalisation", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-1"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "label": "Montant",
      "disabled": _vm.readOnly,
      "vmodel": _vm.declarationOETH.MontantContributionAnneePrecedente
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationOETH, "MontantContributionAnneePrecedente", $event)
      }
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer mt-3"
  }, [_c('div', {
    staticClass: "area-action"
  }, [(!_vm.readOnly) ? _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Enregistrer")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal blue ml-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.next(_vm.readOnly)
      }
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Voir le résultat")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s((!_vm.readOnly) ? 'Annuler' : 'Fermer'))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Formulaire de saisie")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Renseignements principaux")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Effectif moyen annuel de beneficiaire de l'obligation d'emploi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text flex-grow-1 ml-3"
  }, [_vm._v("Effectifs de BOETH dans l'entreprise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text flex-grow-1 ml-3"
  }, [_vm._v("Bénéficiare de l'OETH intérimaires ou mis à disposition dans l'entreprise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "title": "Mise en place d'un accord agréé d'entreprise, de groupe ou de branche sur l'emploi des personnes handicapées"
    }
  }, [_vm._v("\n                         Mise en place d'un accord agréé d'entreprise, de groupe ou de branche sur l'emploi des personnes handicapées\n                     ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Détermination du coefficient de l'entreprise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Déduction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Effectif moyen annuel de personnes relevant d'un ECAP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de sous-traitance Esat/EA/TIH/EPS non plafonné (30% du coût de la main d'oeuvre)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses liées à la réalisation de diagnostics et de travaux d'accessibilité pour les bénéficiaires de l'obligation emploi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses liées à la mise en oeuvre de moyens humains, techniques ou organisationnels destinées à compenser le handicap, à la formation des salariés bénéficiaires de l'obligation d'emploi pour permettre leur maintien dans l'emploi et leur reconversion professionnelle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses liées aux prestations d'accompagnement des personnes handicapées bénéficiaires de l'obligation d'emploi et à la formation des salariés de l'entreprise au handicap")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses déductibles liées à la particpation à des événements")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses déductibles liées aux partenariats avec des associations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Dépenses déductibles liées aux actions concourant à la professionnalisation et aux achats auprès des EA, ESAT, TIH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Contribution nette après écrêtement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_c('u', {
    staticClass: "font-weight-bold"
  }, [_vm._v("MESURES TRANSITOIRES")]), _c('br'), _vm._v("Montant de la contribution de l'ensemble de l'entreprise de l'année N-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db843860"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsn/modalSaisieOeth/modalSaisieOeth.vue.html
// module id = a331
// module chunks = 2